import { 
  cilUser, 
  cilLockLocked, 
  cilAccountLogout, 
  cilPeople, 
  cilBuilding, 
  cilInstitution, 
  cilMap, 
  cilSettings, 
  cilSpeedometer, 
  cilMenu, 
  cilBell, 
  cilList, 
  cilPlus, 
  cilPencil, 
  cilTrash, 
  cilMagnifyingGlass, 
  cilExitToApp, 
  cilEnvelopeClosed, 
  cilArrowRight, 
  cilCheck, 
  cilX, 
  cilWarning, 
  cilInfo, 
  cilFile, 
  cilSave, 
  cilPrint
} from '@coreui/icons'

export const iconsSet = {
  cilUser,
  cilLockLocked,
  cilAccountLogout,
  cilPeople,
  cilBuilding,
  cilInstitution,
  cilMap,
  cilSettings,
  cilSpeedometer,
  cilMenu,
  cilBell,
  cilList,
  cilPlus,
  cilPencil,
  cilTrash,
  cilMagnifyingGlass,
  cilExitToApp,
  cilEnvelopeClosed,
  cilArrowRight,
  cilCheck,
  cilX,
  cilWarning,
  cilInfo,
  cilFile,
  cilSave,
  cilPrint
}